module.exports = __webpack_public_path__ + "static/blackfriday-2aff7b2a16dbbf7fca652f9380afd065.png";